/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../../../Fixes';
import Builder from '../../../../../../../Builder';
import '../../../../../../common/currency';
import '../../../../../../addons/shared/first_party_addons';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "devicesettings": {
        "nested": {
          "profiles": {
            "nested": {
              "v2": {
                "nested": {
                  "model": {
                    "nested": {
                      "settings": {
                        "nested": {
                          "addons": {
                            "nested": {
                              "CashManagement": {
                                "fields": {
                                  "isEnabled": {
                                    "type": "bool",
                                    "id": 1,
                                    "rule": "optional",
                                    "options": {
                                      "default": true
                                    }
                                  },
                                  "defaultStartingAmount": {
                                    "type": ".squareup.common.Money",
                                    "id": 2,
                                    "rule": "optional"
                                  },
                                  "autoEmailReport": {
                                    "type": "bool",
                                    "id": 3,
                                    "rule": "optional",
                                    "options": {
                                      "default": true
                                    }
                                  },
                                  "reportRecipientEmail": {
                                    "type": "string",
                                    "id": 4,
                                    "rule": "optional"
                                  },
                                  "autoPrintReport": {
                                    "type": "bool",
                                    "id": 5,
                                    "rule": "optional",
                                    "options": {
                                      "default": true
                                    }
                                  },
                                  "firstPartyAddon": {
                                    "type": ".squareup.addons.shared.FirstPartyAddon",
                                    "id": 6,
                                    "rule": "optional",
                                    "options": {
                                      "default": "CASH_MANAGEMENT"
                                    }
                                  },
                                  "requireNotes": {
                                    "type": "bool",
                                    "id": 7,
                                    "rule": "optional",
                                    "options": {
                                      "default": false
                                    }
                                  },
                                  "requireUpdateBalance": {
                                    "type": "bool",
                                    "id": 8,
                                    "rule": "optional",
                                    "options": {
                                      "default": false
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.addons?.nested?.CashManagement) {
  $root.addJSON(jsonData);
}

/**
 * IMPORTANT: When Adding New Fields to Device Profiles, you MUST implement their default values at:
 *
 * /java/device-settings/src/main/java/com/squareup/devicesettings/processing/profiles/v2/defaults
 *
 * ⚠️ WARNING: Fields will not be automatically hydrated unless default values are implemented in the Java code above.
 * This is a mandatory step for all device profile settings.
 *
 * SOURCE CashManagement @ squareup/devicesettings/profiles/v2/model/settings/addons/cash_management.proto at 21:1
 */
export const CashManagement = $root.lookupType('squareup.devicesettings.profiles.v2.model.settings.addons.CashManagement');
fixType(CashManagement);
Builder.createAndAttachToType(CashManagement);